// Hero video: the poster is the LCP, so the (multi-MB) video only starts downloading once the
// page has finished loading and the main thread is idle. On data saver, slow connections or
// reduced motion the poster is all the visitor gets.
const shouldSkipVideo = () => {
    const connection = navigator.connection;
    if (connection && (connection.saveData || /2g|3g/.test(connection.effectiveType || ""))) {
        return true;
    }
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
};

const startVideo = async (videoElement) => {
    try {
        videoElement.load(); // Force the browser to pick the right <source>
        await videoElement.play();
    } catch (error) {
        if (error.name === "NotAllowedError" || error.name === "AbortError") {
            // Autoplay blocked (browser policy or iOS Low Power Mode): keep the poster.
            videoElement.removeAttribute("src");
        } else {
            console.error("Video playback failed:", error);
        }
    }
};

const init = () => {
    const videoElement = document.getElementById("hero-video");
    if (!videoElement || shouldSkipVideo()) return;

    const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 200));
    idle(() => startVideo(videoElement), { timeout: 2000 });
};

if (document.readyState === "complete") {
    init();
} else {
    window.addEventListener("load", init, { once: true });
}
